import API from "../../axiosConfig/axiosConfig"
import { store } from "../../store"
import { PARTNER_DETAILS_FETCHED, SET_PARTNER_DETAILS } from "../types/types"
import _ from "../../utils/lodashUtils"
import { FirebaseService, FIREBASE_STATE_KEYS } from "../../firebase"
import { ENDPOINTS } from "../../constants/apiEndPoints"

// Set the chat space name
export const setChatSpaceName = (chatSpaceName) => async (dispatch) => {
  const body = {
    chat_space_name: chatSpaceName,
  }

  try {
    const response = await API.post(ENDPOINTS.SET_CHATSPACE_NAME, body)
    dispatch({
      type: PARTNER_DETAILS_FETCHED,
      payload: response.data,
    })
    dispatch({
      type: SET_PARTNER_DETAILS,
      payload: response.data,
    })
    FirebaseService.patch({
      [FIREBASE_STATE_KEYS.CHAT_SPACE_NAME]: response.data.chat_space_name,
      path: FirebaseService.getDefaultPath(),
    })
    const partnerAccepted = _.get(
      store.getState(),
      "invitePeople.partnerDetails.partner2_status",
      {}
    )
  } catch (err) {}
}
